import { VirtualizerController } from './virtualizer.controller';
import { VirtualizerProps } from './virtualizer.model';

export const Virtualizer = <T,>(props: VirtualizerProps<T>) => {
  return <VirtualizerController {...props} />;
};
